var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7541_11041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.31834 4.97398C6.64646 3.90987 8.29817 3.33127 10 3.33398C11.7708 3.33398 13.3983 3.94732 14.6817 4.97398L15.8925 3.76315L17.0708 4.94148L15.86 6.15232C16.7414 7.25578 17.2934 8.58568 17.4523 9.98898C17.6113 11.3923 17.3708 12.8119 16.7586 14.0846C16.1463 15.3573 15.1872 16.4312 13.9915 17.1828C12.7959 17.9344 11.4123 18.3332 10 18.3332C8.58773 18.3332 7.20415 17.9344 6.0085 17.1828C4.81284 16.4312 3.85369 15.3573 3.24144 14.0846C2.62918 12.8119 2.3887 11.3923 2.54767 9.98898C2.70663 8.58568 3.25858 7.25578 4.14 6.15232L2.92917 4.94232L4.1075 3.76398L5.31834 4.97482V4.97398ZM10 16.6673C10.766 16.6673 11.5246 16.5164 12.2323 16.2233C12.9401 15.9301 13.5831 15.5005 14.1248 14.9588C14.6665 14.4171 15.0962 13.774 15.3893 13.0663C15.6825 12.3586 15.8333 11.6 15.8333 10.834C15.8333 10.0679 15.6825 9.3094 15.3893 8.60167C15.0962 7.89393 14.6665 7.25087 14.1248 6.7092C13.5831 6.16752 12.9401 5.73784 12.2323 5.44469C11.5246 5.15154 10.766 5.00065 10 5.00065C8.45291 5.00065 6.96918 5.61523 5.87522 6.7092C4.78125 7.80316 4.16667 9.28689 4.16667 10.834C4.16667 12.3811 4.78125 13.8648 5.87522 14.9588C6.96918 16.0527 8.45291 16.6673 10 16.6673ZM10.8333 10.0007H13.3333L9.16667 15.4173V11.6673H6.66667L10.8333 6.24648V10.0007ZM6.66667 0.833984H13.3333V2.50065H6.66667V0.833984Z",
    fill: "#213D69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7541_11041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.69d8727621be285df6d98b981b345a76.svg";
export { ForwardRef as ReactComponent };